import React from "react";

const Footer = () => {
  return (
    <footer className="py-12 bg-primary">
      <div className="container mx-auto">
        <p className="text-center text-white">
          Copyright &copy; Ecommerce Shop 2023. All rights recerved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
